/*
 * Observe Boost changes once. Other apps also mutate the document during page
 * load; their changes must not trigger five full-page product/filter scans.
 * Keep watching the document so replacing Boost's root on paging/search works.
 */
(function() {
  var handlers = [];

  function touchesSelector(record, selector) {
    var target = record.target;
    if (record.type === 'characterData') {
      var parent = target.parentElement;
      return Boolean(parent && parent.closest(selector));
    }
    if (record.type === 'attributes') {
      return Boolean(target.closest(selector) || target.querySelector(selector));
    }
    if (target.nodeType === 1 && target.closest(selector)) return true;
    function containsMatch(node) {
      return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
    }
    return Array.prototype.some.call(record.addedNodes, containsMatch) ||
      Array.prototype.some.call(record.removedNodes, containsMatch);
  }

  var boostObserver = new MutationObserver(function(records) {
    var affected = new Map();
    handlers.forEach(function(handler) {
      var key = handler.selector + (handler.redraws ? ' [redraws]' : '');
      if (!affected.has(key)) {
        affected.set(key, records.some(function(record) {
          // In-place redraws (text, filter ids) go to handlers that asked.
          if (record.type !== 'childList' && !handler.redraws) return false;
          return touchesSelector(record, handler.selector);
        }));
      }
      if (affected.get(key)) handler.schedule();
    });
  });
  var watchingRedraws = false;

  // options.redraws: also call schedule when Boost redraws a match in place,
  // by rewriting its text or by reusing a filter block for another filter
  // (it changes data-filteroptionid instead of adding new nodes).
  function observeBoostChanges(selector, schedule, options) {
    var redraws = Boolean(options && options.redraws);
    handlers.push({ selector: selector, schedule: schedule, redraws: redraws });
    if (handlers.length === 1 || (redraws && !watchingRedraws)) {
      watchingRedraws = watchingRedraws || redraws;
      var config = { childList: true, subtree: true };
      if (watchingRedraws) {
        config.characterData = true;
        config.attributes = true;
        config.attributeFilter = ['data-filteroptionid'];
      }
      boostObserver.observe(document.documentElement, config);
    }
    schedule();
  }

/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Meermin Shoes: Image hover swap */

(function() {
  var observerTimer;
  var hoverCapability = window.matchMedia ? window.matchMedia('(any-hover: hover)') : null;
  var preparedPrimaryImages = new WeakMap();
  var primaryImageObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;

          var image = entry.target.querySelector('.boost-sd__product-image-img--main');
          if (image) image.removeAttribute('loading');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '800px 0px' })
    : null;

  function withWidth(src, width) {
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function optimizePrimaryImage(item, index) {
    var image = item.querySelector('.boost-sd__product-image-img--main');
    if (!image) return;

    var firstRowCount = window.innerWidth < 750 ? 2 : window.innerWidth < 1100 ? 3 : 4;
    image.decoding = 'async';

    if (index === 0) {
      image.loading = 'eager';
      image.fetchPriority = 'high';
    } else if (index < firstRowCount || !primaryImageObserver) {
      image.removeAttribute('loading');
      image.fetchPriority = 'auto';
    } else {
      /*
       * Boost hides img[loading="lazy"] until its own loader promotes it.
       * Observe the visible product card instead of the hidden image, then
       * promote the image before the card approaches the viewport.
       */
      primaryImageObserver.observe(item);
      image.fetchPriority = 'auto';
    }
  }

  function optimizeAllPrimaryImages() {
    document.querySelectorAll('.boost-sd__product-item').forEach(optimizePrimaryImage);
  }

  /*
   * Boost renders the whole formatted price ("$265 USD", "HK$2,079 HKD",
   * "\u00a542,600 JPY") as one plain text node inside .boost-sd__format-currency
   * -- there is no separate element wrapping just the symbol, so CSS cannot
   * target it. Strip the leading symbol (plus any 1-3 letter country prefix
   * Shopify prepends to it, e.g. the "HK" in "HK$") from the text content
   * instead. Only strips a prefix immediately followed by a digit, so the
   * numeric value and the trailing currency code (USD, HKD, JPY, etc.) are
   * left untouched.
   */
  var LEADING_SYMBOL = /^[A-Z]{0,3}[$\u20ac\u00a3\u00a5\u20b9\u20a9\u20aa\u20a6\u20b4\u20ab\u20b1\u20b2\u20a1\u20b5]\s*(?=\d)/;

  function stripLeadingCurrencySymbols() {
    document.querySelectorAll('.boost-sd__format-currency').forEach(function(span) {
      if (LEADING_SYMBOL.test(span.textContent)) {
        span.textContent = span.textContent.replace(LEADING_SYMBOL, '');
      }
    });
  }

  function addHoverImages() {
    var items = document.querySelectorAll('.boost-sd__product-item');
    if (!items.length) return;

    items.forEach(function(item, index) {
      var primaryImage = item.querySelector('.boost-sd__product-image-img--main');
      if (primaryImage && preparedPrimaryImages.get(primaryImage) !== index) {
        optimizePrimaryImage(item, index);
        preparedPrimaryImages.set(primaryImage, index);
      }

      // Touch-only devices cannot show the hover swap. Keep their bandwidth
      // for primary images, and leave cards eligible if a mouse is attached.
      if (hoverCapability && !hoverCapability.matches) return;
      if (item.hasAttribute('data-hover-done')) return;

      var dataAttr = item.getAttribute('data-product');
      if (!dataAttr) return;

      try {
        var product = JSON.parse(dataAttr);
        if (!product.images || product.images.length < 2) {
          item.setAttribute('data-hover-done', '1');
          return;
        }

        var secondImageSrc = product.images[1].src;
        if (!secondImageSrc) return;

        var wrapper = item.querySelector('.boost-sd__product-image-wrapper');
        if (!wrapper || wrapper.querySelector('.boost-sd__product-image-hover')) return;

        var hoverImg = document.createElement('img');
        // Configure request policy before assigning any image source.
        hoverImg.loading = 'lazy';
        hoverImg.decoding = 'async';
        hoverImg.sizes = '(max-width: 749px) 50vw, (max-width: 1099px) 33vw, 25vw';
        hoverImg.srcset = [320, 480, 600, 800]
          .map(function(width) { return withWidth(secondImageSrc, width) + ' ' + width + 'w'; })
          .join(', ');
        hoverImg.src = withWidth(secondImageSrc, 600);
        hoverImg.alt = product.title || '';
        hoverImg.className = 'boost-sd__product-image-hover';
        wrapper.style.position = 'relative';
        wrapper.appendChild(hoverImg);
        item.setAttribute('data-hover-done', '1');
      } catch(e) {
        item.setAttribute('data-hover-done', '1');
        console.warn('[Boost hover image] Could not prepare product image', e);
      }
    });
  }

  // Boost draws (and redraws, on paging/filtering) its cards client-side.
  // Handle new cards in a microtask after each DOM change, before the next
  // paint, so prices never show with the symbol and hover images are ready.
  // Watches the document, not one container, since Boost can replace its root.
  var pending = false;
  var resizeBound = false;

  function run() {
    if (!document.querySelector('.boost-sd__product-item')) return;
    addHoverImages();
    stripLeadingCurrencySymbols();
    if (!resizeBound) {
      resizeBound = true;
      window.addEventListener('resize', function() {
        clearTimeout(observerTimer);
        observerTimer = setTimeout(optimizeAllPrimaryImages, 100);
      }, { passive: true });
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      run();
    });
  }

  if (hoverCapability) {
    if (hoverCapability.addEventListener) hoverCapability.addEventListener('change', schedule);
    else if (hoverCapability.addListener) hoverCapability.addListener(schedule);
  }

  observeBoostChanges('.boost-sd__product-item', schedule);
})();

/* Meermin Shoes: keep the collection in product links on collection pages.
   Boost's product-item template hard-codes /products/<handle> (its
   addCollectionToProductUrl setting isn't applied), but PDP Builder.io content
   is targeted on the URL path (e.g. request.path contains "women"), so a unisex
   product opened from /collections/womens-boots must land on
   /collections/womens-boots/products/<handle>. Query strings
   such as ?variant= are kept. Search pages are left as they are. */
(function() {
  var match = window.location.pathname.match(/^((?:\/[a-z]{2}(?:-[a-z]{2})?)?)\/collections\/([^\/]+)\/?$/i);
  if (!match) return;

  var locale = match[1];
  var prefix = locale + '/collections/' + match[2];
  var productPath = new RegExp('^' + locale.replace(/[-\/]/g, '\\$&') + '/products/');
  var pending = false;

  function rewriteLinks() {
    document.querySelectorAll('.boost-sd__product-item a[href]').forEach(function(link) {
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin || !productPath.test(url.pathname)) return;
      link.setAttribute('href', prefix + url.pathname.slice(locale.length) + url.search + url.hash);
    });
  }

  // Run before the next paint (microtask), so Boost's cards never show
  // without our additions; each card is only handled once.
  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      rewriteLinks();
    });
  }

  // Boost renders, paginates and filters client-side (sometimes replacing its
  // root node), so watch the whole document rather than one container.
  observeBoostChanges('.boost-sd__product-item', schedule);

  // Boost puts /products/<handle> back into the card link on mousedown and
  // opens the product from its own click handler, so the rewritten href
  // alone isn't followed. A plain click is taken over before Boost sees it;
  // for new-tab clicks (modifier keys, middle click, right-click menu) the
  // link itself is corrected, since the browser follows it.
  function collectionUrl(link) {
    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch (e) {
      return null;
    }
    if (url.origin !== window.location.origin || !productPath.test(url.pathname)) return null;
    return prefix + url.pathname.slice(locale.length) + url.search + url.hash;
  }

  function productLink(event) {
    var target = event.target;
    if (!target.closest || target.closest('button, input, select, label')) return null;
    return target.closest('.boost-sd__product-item a[href]');
  }

  window.addEventListener('click', function(event) {
    var link = productLink(event);
    if (!link || event.defaultPrevented) return;
    var href = collectionUrl(link);
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      if (href) link.setAttribute('href', href);
      return;
    }
    if (!href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(href);
  }, true);

  ['auxclick', 'contextmenu'].forEach(function(type) {
    window.addEventListener(type, function(event) {
      var link = productLink(event);
      var href = link && collectionUrl(link);
      if (href) link.setAttribute('href', href);
    }, true);
  });
})();

/* Meermin Shoes: tag badges (New / Sale / Best Seller) on Boost product cards.
   Same tags, text, colours and markup as snippets/product-card-badges.liquid
   on the PDP and theme cards, configured in Theme settings → Badges and passed
   in as #ProductTagBadges. Boost puts each product's tags in data-product. A
   badge can also list product handles picked in the theme editor. */
(function() {
  var config;
  try {
    config = JSON.parse(document.getElementById('ProductTagBadges').textContent);
  } catch (e) {
    return;
  }
  var badges = (config.badges || []).filter(function(badge) {
    return badge.label && (badge.tag || (badge.handles && badge.handles.length));
  });
  if (!badges.length) return;
  var pending = false;

  function productData(item) {
    try {
      var data = JSON.parse(item.getAttribute('data-product'));
      if (typeof data === 'string') data = JSON.parse(data);
      return data || {};
    } catch (e) {
      return {};
    }
  }

  // A badge can skip product types (e.g. Unlined skips Belts); Boost puts the
  // product type in data-product as "category".
  function excluded(badge, type) {
    if (!badge.excludeTypes) return false;
    var current = String(type || '').trim().toLowerCase();
    return badge.excludeTypes.split(',').some(function(name) {
      name = name.trim().toLowerCase();
      return name && name === current;
    });
  }

  // A badge can be hidden on collections where it says nothing (e.g. New on
  // New Arrivals, where every product is new).
  var collectionMatch = window.location.pathname.match(/\/collections\/([^\/]+)\/?$/);
  var currentCollection = collectionMatch ? decodeURIComponent(collectionMatch[1]).toLowerCase() : '';

  // The product's handle: from data-product, else from the card's link.
  function productHandle(item, data) {
    if (data.handle) return data.handle;
    var link = item.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function applies(badge, item, data) {
    if (badge.tag && (data.tags || []).indexOf(badge.tag) !== -1) return true;
    return !!badge.handles && badge.handles.indexOf(productHandle(item, data)) !== -1;
  }

  function hiddenHere(badge) {
    if (!badge.hideOnCollections || !currentCollection) return false;
    return badge.hideOnCollections.split(',').some(function(handle) {
      return handle.trim().toLowerCase() === currentCollection;
    });
  }

  function render() {
    // Marked per image wrapper: Boost can re-render a card's inner markup.
    document.querySelectorAll('.boost-sd__product-item .boost-sd__product-image-wrapper:not([data-tag-badges])').forEach(function(wrapper) {
      var item = wrapper.closest('.boost-sd__product-item');
      wrapper.setAttribute('data-tag-badges', '');
      var data = productData(item);
      var corners = {};
      badges.forEach(function(badge) {
        if (!applies(badge, item, data) || excluded(badge, data.category) || hiddenHere(badge)) return;
        // Placement "name": a small tag at the end of the product name instead
        // of a badge on the image (e.g. Unlined).
        if (badge.placement === 'name') {
          var title = item.querySelector('.boost-sd__product-title');
          if (title && !title.querySelector('.boost-sd__product-title-tag')) {
            var tag = document.createElement('span');
            // The badge's colour scheme (Theme settings → Badges), like New.
            tag.className = 'boost-sd__product-title-tag color-' + badge.scheme;
            tag.textContent = badge.label;
            // Keep the name's last word and the tag together, so a long name
            // wraps as "... - E [Unlined]" rather than leaving the tag alone.
            var name = title.textContent.replace(/\s+/g, ' ').trim();
            var split = name.lastIndexOf(' ');
            var keep = document.createElement('span');
            keep.className = 'boost-sd__product-title-end';
            keep.textContent = name.slice(split + 1) + ' ';
            keep.appendChild(tag);
            title.textContent = split === -1 ? '' : name.slice(0, split + 1);
            title.appendChild(keep);
          }
          return;
        }
        if (!corners[badge.corner]) {
          corners[badge.corner] = document.createElement('div');
          corners[badge.corner].className = 'product-badges product-badges--' + badge.corner;
          corners[badge.corner].setAttribute('style', config.style || '');
          wrapper.appendChild(corners[badge.corner]);
        }
        var el = document.createElement('div');
        el.className = 'product-badges__badge product-badges__badge--rectangle ' +
          (badge.style === 'outline' ? 'product-badges__badge--outline' : 'color-' + badge.scheme);
        el.textContent = badge.label;
        corners[badge.corner].appendChild(el);
      });
    });
  }

  // Run before the next paint (microtask), so Boost's cards never show
  // without our additions; each card is only handled once.
  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      render();
    });
  }

  // Boost renders, paginates and filters client-side, so watch the document.
  observeBoostChanges('.boost-sd__product-item', schedule);
})();

/* Meermin Shoes: filter values from tags read as words.
   Tag filters show the value after the prefix (style:penny-loafer ->
   "penny-loafer", capitalised by CSS). Swap the hyphens for spaces in the
   displayed text only ("Penny Loafer"); the filter values themselves are
   untouched. Only single hyphen-joined values with letters are changed
   (e-(medium) -> "E (medium)"), so sizes and prices stay as they are. */
(function() {
  var SELECTOR = '.boost-sd__filter-option-item-label, [class*="boost-sd__refine-by"]';
  // One hyphen-joined token with letters, e.g. penny-loafer, e-(medium).
  var HYPHENATED = /^\s*(?=\S*[A-Za-z])\S+-\S+\s*$/;
  var pending = false;

  function tidy() {
    document.querySelectorAll(SELECTOR).forEach(function(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (HYPHENATED.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/-/g, ' ');
      }
    });
  }

  // Run before the next paint (microtask), so Boost's cards never show
  // without our additions; each card is only handled once.
  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      tidy();
    });
  }

  observeBoostChanges(SELECTOR, schedule);
})();

/* Meermin Shoes: "Nova Last · Diamond Latex Sole" under the product name on
   Boost cards, from the last:<value> and sole:<value> tags Boost puts in
   data-product. Words are capitalised like the PDP details
   (snippets/spec-capitalize-word.liquid): the letter after "(" too, and short
   bracketed codes uppercased. */
(function() {
  var pending = false;

  function capitalizeWord(word) {
    if (word.charAt(0) === '(') {
      var inner = word.slice(1);
      if (inner.replace(')', '').length <= 3) return '(' + inner.toUpperCase();
      return '(' + inner.charAt(0).toUpperCase() + inner.slice(1).toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  function tagValue(tags, key) {
    for (var i = 0; i < tags.length; i++) {
      var parts = String(tags[i]).split(':');
      if (parts.length >= 2 && parts[0].trim().toLowerCase() === key) {
        return parts[1].trim().replace(/[-_]/g, ' ').split(/\s+/).filter(Boolean).map(capitalizeWord).join(' ');
      }
    }
    return '';
  }

  function productTags(item) {
    try {
      var data = JSON.parse(item.getAttribute('data-product'));
      if (typeof data === 'string') data = JSON.parse(data);
      return data.tags || [];
    } catch (e) {
      return [];
    }
  }

  function render() {
    document.querySelectorAll('.boost-sd__product-item .boost-sd__product-title:not([data-last-sole])').forEach(function(title) {
      title.setAttribute('data-last-sole', '');
      var tags = productTags(title.closest('.boost-sd__product-item'));
      var last = tagValue(tags, 'last');
      var sole = tagValue(tags, 'sole');
      var parts = [];
      if (last) parts.push(last + ' Last');
      if (sole) parts.push(sole + ' Sole');
      if (!parts.length) return;
      var line = document.createElement('div');
      line.className = 'boost-sd__product-last-sole';
      // Each half stays on one line, so narrow cards wrap at the dot.
      parts.forEach(function(text, index) {
        var span = document.createElement('span');
        span.textContent = index < parts.length - 1 ? text + ' ·' : text;
        line.appendChild(span);
        if (index < parts.length - 1) line.appendChild(document.createTextNode(' '));
      });
      title.insertAdjacentElement('afterend', line);
    });
  }

  // Run before the next paint (microtask), so Boost's cards never show
  // without our additions; each card is only handled once.
  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      render();
    });
  }

  observeBoostChanges('.boost-sd__product-item', schedule);
})();

/* Meermin Shoes: search page, Collections and Pages tabs. Boost only gives
 * each result a title and link; the theme's ?view=search-card templates add
 * the rest (templates/collection.search-card.liquid, page.search-card.liquid).
 * Collections become image tiles like the subcollection tiles on collection
 * pages (empty collections are hidden); pages become a list with their search
 * description. Results are cached per session. Styles: boost-sd-custom.css.
 */
(function() {
  var ITEM = '.boost-sd__search-result-panel-content-item';
  var cards = {};
  var pending = false;

  function card(path) {
    if (cards[path]) return cards[path];
    var key = 'search-card:' + path;
    var stored = null;
    try { stored = sessionStorage.getItem(key); } catch (e) {}
    cards[path] = stored ? Promise.resolve(JSON.parse(stored)) : fetch(path + '?view=search-card', { credentials: 'same-origin' })
      .then(function(response) { return response.ok ? response.text() : null; })
      .then(function(text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
        if (data) { try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) {} }
        return data;
      })
      .catch(function() { return null; });
    return cards[path];
  }

  // Page descriptions can arrive HTML-escaped ("For Her &amp; Him").
  function decode(text) {
    return new DOMParser().parseFromString(text, 'text/html').documentElement.textContent;
  }

  function meta(item, text) {
    var holder = item.querySelector('.boost-sd__search-result-panel-content-item-text') || item;
    var line = document.createElement('span');
    line.className = 'search-card__meta';
    line.textContent = text;
    holder.appendChild(line);
  }

  function decorate(item) {
    item.setAttribute('data-search-card', '');
    var path;
    try { path = new URL(item.getAttribute('href') || '', window.location.origin).pathname; } catch (e) { return; }
    var title = (item.querySelector('.boost-sd__search-result-panel-content-item-title') || item).textContent.trim();

    if (/^\/collections\/[^/]+$/.test(path)) {
      item.classList.add('search-card', 'search-card--collection');
      item.parentElement.classList.add('search-cards', 'search-cards--collections');
      var media = document.createElement('span');
      media.className = 'search-card__media';
      item.insertBefore(media, item.firstChild);
      card(path).then(function(data) {
        if (!data) return;
        if (data.count === 0) { item.hidden = true; return; }
        if (data.image) {
          var image = document.createElement('img');
          image.className = 'search-card__image';
          image.alt = '';
          image.decoding = 'async';
          image.src = data.image;
          media.appendChild(image);
        }
        if (typeof data.count === 'number') meta(item, data.count + (data.count === 1 ? ' product' : ' products'));
      });
    } else if (/^\/pages\/[^/]+$/.test(path)) {
      item.classList.add('search-card', 'search-card--page');
      item.parentElement.classList.add('search-cards', 'search-cards--pages');
      card(path).then(function(data) {
        var description = data && data.description ? decode(data.description).trim() : '';
        if (description && description.toLowerCase() !== title.toLowerCase()) meta(item, description);
      });
    }
  }

  function render() {
    document.querySelectorAll(ITEM + ':not([data-search-card])').forEach(decorate);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      render();
    });
  }

  observeBoostChanges(ITEM, schedule);
})();

/* Meermin Shoes: size filters in size order (2, 3, 4 ... 9.5, 10, 10.5).
   Boost's "key-asc" sort compares the values as text, so 10-12 came before
   2. Reorder each size filter's values by their leading number; values
   without one (One Size) keep their order at the end. Boost's filter
   actions are delegated (data-metadata), so moving the items is safe, and
   moving the elements keeps the keyboard order matching what's shown. */
(function() {
  var LIST = '.boost-sd__filter-option[data-filteroptionid*="size"] .boost-sd__filter-option-listitem';
  var pending = false;

  function sizeKey(item) {
    var label = item.querySelector('.boost-sd__filter-option-item-label');
    var match = /^\s*(\d+(?:\.\d+)?)/.exec(label ? label.textContent : '');
    return match ? parseFloat(match[1]) : Infinity;
  }

  function sortList(list) {
    var items = Array.prototype.filter.call(list.children, function(child) {
      return child.tagName === 'LI';
    });
    var sorted = items
      .map(function(item, index) { return { item: item, key: sizeKey(item), index: index }; })
      .sort(function(a, b) { return a.key - b.key || a.index - b.index; })
      .map(function(entry) { return entry.item; });
    // Only touch the DOM when the order is wrong, so our own moves don't
    // keep re-triggering the observer.
    if (sorted.every(function(item, index) { return item === items[index]; })) return;
    sorted.forEach(function(item) { list.appendChild(item); });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      document.querySelectorAll(LIST).forEach(sortList);
    });
  }

  // Boost also redraws filters in place: rewriting the labels inside the
  // existing items (back in its own order), or turning another filter's
  // block into the size filter by changing its data-filteroptionid.
  observeBoostChanges(LIST, schedule, { redraws: true });
})();

/* Meermin Shoes: "Filter" toggle for the horizontal filter bar (desktop).
   One toolbar row, as on the 1.0 theme: Filter on the left, the product
   count and Sort by on the right. The bar of filter dropdowns sits under
   it and stays hidden until Filter is pressed (boost-sd-custom.css,
   section 10); the choice lasts while the page is open, through Boost's
   re-renders. Phones keep Boost's own Refine By drawer. */
(function() {
  var OPEN_CLASS = 'boost-filters-open';
  var TOOLBAR = '.boost-sd-layout--has-filter-horizontal .boost-sd__toolbar';
  var ICON = '<svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
    '<path d="M2 5h9.5M14.5 5H18M2 10h3.5M8.5 10H18M2 15h9.5M14.5 15H18" stroke="currentColor"/>' +
    '<circle cx="13" cy="5" r="1.5" stroke="currentColor"/>' +
    '<circle cx="7" cy="10" r="1.5" stroke="currentColor"/>' +
    '<circle cx="13" cy="15" r="1.5" stroke="currentColor"/></svg>';
  var pending = false;

  function isOpen() {
    return document.documentElement.classList.contains(OPEN_CLASS);
  }

  function toggle(event) {
    var open = document.documentElement.classList.toggle(OPEN_CLASS);
    event.currentTarget.setAttribute('aria-expanded', String(open));
  }

  // Boost lays the page out for phones below 992px (its Refine By drawer),
  // and for desktop above it, once per page load.
  function isDesktopLayout() {
    var column = document.querySelector('.boost-sd-layout--has-filter-horizontal .boost-sd-left');
    return document.documentElement.clientWidth >= 992 &&
      Boolean(column) && getComputedStyle(column).display !== 'none';
  }

  function render() {
    var toolbar = document.querySelector(TOOLBAR);
    // Boost redraws its toolbar and can reuse nodes it doesn't own, so drop
    // any toggle that ended up outside its own item.
    document.querySelectorAll('.boost-filter-toggle').forEach(function(button) {
      if (!button.parentElement || !button.parentElement.classList.contains('boost-filter-toggle-item')) {
        button.remove();
      }
    });
    if (!toolbar || !isDesktopLayout()) {
      document.querySelectorAll('.boost-filter-toggle-item').forEach(function(item) { item.remove(); });
      return;
    }
    if (toolbar.querySelector('.boost-filter-toggle-item > .boost-filter-toggle')) return;
    var item = document.createElement('div');
    item.className = 'boost-sd__toolbar-item boost-filter-toggle-item';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'boost-filter-toggle';
    button.setAttribute('aria-expanded', String(isOpen()));
    button.innerHTML = ICON + '<span>Filter</span>';
    button.addEventListener('click', toggle);
    item.appendChild(button);
    // Appended after Boost's own items so its redraws don't reuse this node;
    // CSS puts it first in the row.
    toolbar.appendChild(item);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(function() {
      pending = false;
      render();
    });
  }

  observeBoostChanges('.boost-sd-layout', schedule);
  window.addEventListener('resize', schedule);
})();

/* Meermin Shoes: Apply button for the horizontal filter dropdowns (desktop),
   as on the 1.0 theme. Boost applies a horizontal filter when a click lands
   outside it, so the button needs no handler of its own: it lives outside
   Boost's markup (on the body) and is placed over the bottom of the open
   dropdown, which keeps room for it (boost-sd-custom.css, section 10). */
(function() {
  var LIST = '.boost-sd-layout--has-filter-horizontal .boost-sd__filter-option--horizontal .boost-sd__filter-option-itemwrapper';
  var button = null;
  var pending = false;

  function openList() {
    var lists = document.querySelectorAll(LIST);
    for (var i = 0; i < lists.length; i++) {
      if (lists[i].offsetHeight > 0) return lists[i];
    }
    return null;
  }

  function applyButton() {
    if (button && button.isConnected) return button;
    button = document.createElement('button');
    button.type = 'button';
    button.className = 'boost-filter-apply';
    button.textContent = 'Apply';
    button.hidden = true;
    document.body.appendChild(button);
    return button;
  }

  function place() {
    var list = document.documentElement.clientWidth >= 992 ? openList() : null;
    var applyEl = applyButton();
    if (!list) {
      applyEl.hidden = true;
      return;
    }
    var rect = list.getBoundingClientRect();
    var style = getComputedStyle(list);
    // The full-width panel (Boost's three-column style) floats over the
    // products; the filter bar reserves its height so it pushes them down,
    // as on the 1.0 theme (boost-sd-custom.css, section 10).
    var bar = list.closest('.boost-sd__filter-tree-horizontal-option-list');
    if (bar) {
      var reserved = parseFloat(getComputedStyle(bar).paddingBottom) || 0;
      var panelBelowBar = rect.bottom - (bar.getBoundingClientRect().bottom - reserved);
      document.documentElement.style.setProperty('--boost-filter-panel-height', Math.max(0, panelBelowBar) + 'px');
    }
    applyEl.hidden = false;
    applyEl.style.left = (rect.left + window.scrollX + parseFloat(style.paddingLeft)) + 'px';
    applyEl.style.top = (rect.bottom + window.scrollY - 24 - applyEl.offsetHeight) + 'px';
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function() {
      pending = false;
      place();
    }, 0);
  }

  // Boost opens and closes a dropdown by restyling it, without adding nodes,
  // so re-place after clicks (once Boost has handled them) as well.
  document.addEventListener('click', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  observeBoostChanges('.boost-sd__filter-tree-horizontal', schedule);
})();

})();
